export const pipelinePagesTypes = {
  RenewalOverview: 1,
  ServiceRequestsOverview: 2,
  EndorsementsOverview: 3,
  TaskOverview: 4,
  OpportunitiesOverview: 5,
  ServiceRequestsStagesOverview: 6,
  ServiceRequestsCustomTypesOverview: 7,
};

export const taskPipelineCustomFilterTypes = Object.freeze({
  AllTasks: { key: 'AllTasks', value: 0, label: 'All Tasks' },
  DueToday: { key: 'DueToday', value: 1, label: 'Due Today' },
  Overdue: { key: 'Overdue', value: 2, label: 'Overdue' },
  RecentlyCompleted: { key: 'RecentlyCompleted', value: 3, label: 'Recently Completed' },
});
